import React from "react";
import { ImageElement } from "../../../components";
import { Link } from "react-router-dom";
import './error.page.scss';

function PageNotFound() {
  return (
    <>
      <div className="pageNot">
        <div className="pageNot_img">
          <ImageElement source="404-img.svg" alt="404-image" isLightbox={false} />
        </div>
        <div className="pageNot_info">
          <h1 className="pageNot_title">Oops! Something went wrong</h1>
          <p>The page you're looking for isn't available. Please check the URL, return to the homepage, or contact support for help.</p>
          <Link to="/" className="pageNot_link">Back to Home</Link>
        </div>
      </div>
    </>
  );
}

export default PageNotFound;
